module.exports = __webpack_public_path__ + "static/donate-72c3d15f37b79fec6401ffca3dcbbb44.png";